"use strict";
exports.__esModule = true;
exports.toCategory = void 0;
var types_1 = require("../../types");
var CATEGORY_PRISMIC_TO_LGLP = {
    Innovation: types_1.Category.Services,
    'Idée reçue': types_1.Category.Misconception,
    Veille: types_1.Category.RightNow,
    Évènement: types_1.Category.Event,
    Podcast: types_1.Category.Interview,
    'Grand angle': types_1.Category.Case,
    Récit: types_1.Category.Lifespiration,
    Éclairage: types_1.Category.PointOfView,
    'Start-up': types_1.Category.Focus,
    Repères: types_1.Category.KeysFigures,
    Rencontre: types_1.Category.Portrait,
    'Page interne': types_1.Category.InnerPage,
    Publication: types_1.Category.Publication
};
var toCategory = function (prismicCategory, logger) {
    return logger.toConstValue(prismicCategory, CATEGORY_PRISMIC_TO_LGLP);
};
exports.toCategory = toCategory;
//# sourceMappingURL=category.js.map